import { Mutex } from 'async-mutex';
// @ts-ignore
import type * as RCL from 'rclnodejs';

import { getRCL } from '@sb/ros/getRCL';

import { BaseService } from './BaseService';

export class IKCollisionCheckService extends BaseService<
  'standard_bots_msgs/srv/IKCollisionCheck',
  RCL.standard_bots_msgs.srv.IKCollisionCheck_Request,
  RCL.standard_bots_msgs.srv.IKCollisionCheck_Response
> {
  private static mutex = new Mutex();

  private goal_pose: RCL.geometry_msgs.msg.Pose;

  private check_collision: boolean;

  private seed_state?: number[];

  public constructor(
    goal_pose: RCL.geometry_msgs.msg.Pose,
    check_collision: boolean,
    seed_state?: number[],
  ) {
    super();
    this.goal_pose = goal_pose;
    this.check_collision = check_collision;
    this.seed_state = seed_state;
    this.mutex = IKCollisionCheckService.mutex;
  }

  public override async call(): Promise<RCL.standard_bots_msgs.srv.IKCollisionCheck_Response> {
    /*
     * There is an issue with the ROS2 service server where if multiple requests are sent,
     * the server may not respond to all of them. To avoid this, we use a mutex to ensure only
     * one request is sent at a time.
     *
     * TODO: Remove this when the ROS2 service server is fixed.
     */
    return super.call();
  }

  protected override getType(): RCL.TypeClass<keyof RCL.ServicesMap> {
    return 'standard_bots_msgs/srv/IKCollisionCheck';
  }

  protected override getServiceName() {
    return 'solve_ik';
  }

  protected override async createRequest() {
    const rcl = await getRCL();

    const IKCollisionCheck = rcl.require(
      'standard_bots_msgs/srv/IKCollisionCheck',
    );

    const request = new IKCollisionCheck.Request();

    request.goal_pose = this.goal_pose;
    request.check_collision = this.check_collision;

    request.seed_state = rcl.createMessageObject('sensor_msgs/msg/JointState');

    // Set seed_state if provided, otherwise create empty JointState
    if (this.seed_state) {
      request.seed_state.name = [
        'joint0',
        'joint1',
        'joint2',
        'joint3',
        'joint4',
        'joint5',
      ];

      request.seed_state.position = [...this.seed_state];
    }

    return request;
  }

  protected override getTimeout(): number {
    return 100;
  }
}
